import { AsyncPipe } from '@angular/common'
import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core'
import { AuctionFacade } from 'libs/gb-front/auction/data-access/src'
import { map } from 'rxjs'
import { GbBaseCurrency } from 'libs/shared/utils/helpers/src/lib/gb-base-currency'

/**
 * gbCurrency pipe that will add any currency symbol ('narrow' by default)
 * or letter combinations such as HKD$ or AED$ ('wide' symbol format)
 */

@Pipe({
  name: 'gbCurrency',
  pure: false,
})
export class GbCurrencyPipe extends GbBaseCurrency implements PipeTransform {
  constructor(
    private auctionFacade: AuctionFacade,
    private asyncPipe: AsyncPipe,
    @Inject(LOCALE_ID) public locale: string,
  ) {
    super()
  }

  transform(value: number | string | null | undefined, symbolFormat: 'wide' | 'narrow' = 'narrow'): any {
    return this.asyncPipe.transform(
      this.auctionFacade.auctionCurrency$.pipe(
        map((currencyCode: string) => GbCurrencyPipe.getCurrencySymbol(value, currencyCode, this.locale, symbolFormat)),
      ),
    )
  }
}
